'use client'

import { useQueryClient } from '@tanstack/react-query'
import { deleteCookie, getCookie } from 'cookies-next/client'
import { useQueryStates } from 'nuqs'
import { useEffect, useRef } from 'react'
import { useAmplitudeAnalytics } from '../hooks/use-amplitude-analytics'
import {
  useGetReferrerProfile,
  useLinkReferralCode,
} from '../queries/hooks/referralcodes'
import { getReferrerProfileQuery } from '../queries/keys/referralcodes'
import { referralSearchParamsParses } from '../stores/params'
import { ReferralCodeCookieKey } from '../stores/referral'
import { errorToast, successToast } from './ui/toast'

export const ReferralLinking = () => {
  const { ampli } = useAmplitudeAnalytics()
  const { mutate } = useLinkReferralCode()
  const { data: profile } = useGetReferrerProfile()
  const [{ referrer }, setReferrer] = useQueryStates(referralSearchParamsParses)
  const queryClient = useQueryClient()
  const referralCookieCode = useRef(getCookie(ReferralCodeCookieKey))

  useEffect(() => {
    if (profile) {
      const referralCode = referralCookieCode.current || referrer

      if (
        referralCode &&
        profile.can_link_referral_code &&
        profile.referral_code !== referralCode
      ) {
        mutate(
          {
            referral_code: referralCode,
          },
          {
            onSuccess: (_, variables) => {
              successToast('Referral code has been linked.')

              if (ampli) {
                ampli.referralCodeLinked({
                  referralCode: variables.referral_code,
                })
              }

              queryClient.invalidateQueries(getReferrerProfileQuery)
            },
            onError: () => {
              errorToast('Failed to link referral code.')
            },
            onSettled: () => {
              deleteCookie(ReferralCodeCookieKey)

              setReferrer({ referrer: null })
            },
          },
        )
      } else {
        deleteCookie(ReferralCodeCookieKey)

        setReferrer({ referrer: null })
      }
    }
  }, [mutate, setReferrer, ampli, referrer, profile, queryClient])

  return null
}
